var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"inner"},[_c('van-loading',{attrs:{"color":"#fff","size":"24px"}},[_vm._v(_vm._s(_vm.text))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }